<template>
  <div class="btn-group">
    <button v-if="canReview" class="btn btn-success btn-sm" title="Approve" @click="confirmApproving">
      <i class="fas fa-check fa-fw"></i>
    </button>
    <button v-if="canReview" class="btn btn-warning btn-sm" title="Reject" @click="confirmRejecting">
      <i class="fas fa-times fa-fw"></i>
    </button>
    <button v-if="canEdit" class="btn btn-secondary btn-sm" @click="edit">
      <i class="fas fa-edit fa-fw"></i>
    </button>
    <button v-if="canDelete" class="btn btn-danger btn-sm" @click="confirmDeleting">
      <i class="fas fa-trash-alt fa-fw"></i>
    </button>
  </div>
</template>

<script>
export default {
  props: {
    row: Object,
  },

  computed: {
    /**
     * @return {boolean}
     */
    canEdit() {
      return this.row.canEdit;
    },

    /**
     * @return {boolean}
     */
    canDelete() {
      return this.row.canDelete;
    },

    /**
     * @return {boolean}
     */
    canReview() {
      return this.row.canReview;
    },

    /**
     * @return {string}
     */
    editUrl() {
      return this.row.editUrl;
    },

    /**
     * @return {string}
     */
    deleteUrl() {
      return this.row.deleteUrl;
    },

    /**
     * @return {string}
     */
    approveUrl() {
      return this.row.approveUrl;
    },

    /**
     * @return {string}
     */
    rejectUrl() {
      return this.row.rejectUrl;
    },
  },

  methods: {
    /**
     * @event edit
     */
    edit() {
      this.$emit('edit', {row: this.row, url: this.editUrl});
    },

    /**
     * @event delete
     */
    confirmDeleting() {
      this.$confirm('Are you sure you want to delete this item?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      })
          .then(() => this.$emit('delete', {row: this.row, url: this.deleteUrl}))
          .catch(() => null);
    },

    /**
     * @event approve
     */
    confirmApproving() {
      this.$confirm('Approve this message? It will become available to send.', 'Approve', {
        confirmButtonText: 'Approve',
        cancelButtonText: 'Cancel',
        type: 'success'
      })
          .then(() => this.$emit('approve', {row: this.row, url: this.approveUrl}))
          .catch(() => null);
    },

    /**
     * @event reject
     */
    confirmRejecting() {
      this.$confirm('Reject this message? It will not be sendable.', 'Reject', {
        confirmButtonText: 'Reject',
        cancelButtonText: 'Cancel',
        type: 'warning'
      })
          .then(() => this.$emit('reject', {row: this.row, url: this.rejectUrl}))
          .catch(() => null);
    },
  },
}
</script>
